import { parsePhoneNumber } from 'libphonenumber-js'

/**
 * it's important that the backend uses specifically what `libphonenumber-js`'s `formatInternational` returns because the backend needs to use a consistent format, especially if it needs to look up the user by phone number (e.g. when disallowing duplicate phone numbers in the database)
 *
 * @see also [the backend's validator](https://github.com/Acre-Rewards/acre-rewards-api/blob/0eb9eedaf202ac53085c8b0ef64a9c41b554bf56/src/user/validators/InternationalPhoneNumber.ts#L16-L30)
 */
export function formatPhoneNumberForBackend(phoneNumber: string, countryCode?: string) {
  return parsePhoneNumber(
    `${(countryCode?.length ?? 0) > 0 ? `${countryCode} ` : ''}${phoneNumber}` as const,
  ).formatInternational()
}
